export const connections = {
    api: 'https://apipr.provisor.kz/',
}

export default {
    connections
}